import { TwMainColor } from "data/types";

export const getColor = (index: number, colors: TwMainColor[]) => {
  if (index === 1) return colors[0];

  if (index === 2) return colors[1];

  return colors[2];
};
